import React from 'react'

import _map from 'lodash/map'

import { Button, Modal, Message, Icon } from 'semantic-ui-react'

const BinLocationInfo = ({ id, timestamp, type, bin: { serial_number } }) => {
  const date = timestamp.substring(0, 10)
  const action = type === 'REMOVE' ? 'removed from' : 'assigned to'

  return (
    <p>
      Bin ({serial_number}) {action} this location at {date}
    </p>
  )
}

class BinsHistory extends React.PureComponent {
  state = { open: false }

  onOpen = () => {
    this.setState({ open: true })
  }

  close = () => this.setState({ open: false })

  render() {
    const { trigger, loading, items } = this.props
    const { open, error } = this.state

    return (
      <Modal
        trigger={trigger}
        dimmer="blurring"
        size="tiny"
        open={open}
        onOpen={this.onOpen}
        onClose={this.close}
      >
        <Modal.Header>Bins History</Modal.Header>
        <Modal.Content scrolling>
          {_map(items, item => <BinLocationInfo key={item.id} {...item} />)}
          {loading && (
            <Message icon>
              <Icon name="circle notched" loading />
              <Message.Content>
                <Message.Header>Just one second</Message.Header>
                We are fetching the history.
              </Message.Content>
            </Message>
          )}
          {error && <Message error header={error} />}
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content="Close"
            onClick={this.close}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default BinsHistory
